import { AIChatWidget } from './AIChatWidget';
import type { WidgetConfig, WidgetState, WidgetElements } from './types';

(function () {
  'use strict';

  // Prevent multiple instances
  if ((window as any).aiChatWidgetInstance) {
    console.warn('AI Chat Widget already loaded');
    return;
  }

  // Get config from global variable
  const globalConfig: WidgetConfig | undefined = (window as any).aiChatConfig;

  // Validate required config
  if (!globalConfig || !globalConfig.iframeUrl) {
    console.error('AI Chat Widget: Please provide window.aiChatConfig with iframeUrl');
    console.error('Example: window.aiChatConfig = { iframeUrl: "https://your-chat-app.com/chat" }');
    return;
  }

  // Validate URL format
  try {
    new URL(globalConfig.iframeUrl);
  } catch (error) {
    console.error('AI Chat Widget: Invalid iframeUrl provided:', globalConfig.iframeUrl);
    return;
  }

  // Initialize widget
  const widget = AIChatWidget.createAIChatWidget(globalConfig);
  (window as any).aiChatWidgetInstance = widget;

  // Expose public API
  (window as any).AIChatWidget = {
    open: widget.open,
    close: widget.close,
    toggle: widget.toggle,
    destroy: widget.destroy
  };

  // Log successful initialization in development
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    console.log('✅ AI Chat Widget initialized successfully');
    console.log('Config:', globalConfig);
  }
})();

